import KlientkontoerklaeringForm from "./KlientkontoerklaeringForm";
import { useRouteLoaderData } from "react-router";
import { KlientkontoerklaeringByIdLoaderData } from "../../routes/klientkontoerklaering/KlientkontoerklaeringById";
import { reviver } from "../../util/json";
import { Formulartype } from "../../interfaces/klientkontoerklaering";
import { KKE_FORM_INITIAL_VALUES } from "../../constants/klientkontoerklaering/initialValues";
import PageError from "../../routes/PageError";

export default function KlientkontoerklaeringTilsvar({
  loaderRouteId,
  formularType,
}: {
  loaderRouteId: string;
  formularType: Formulartype;
}) {
  const { kke, metadata, error } = useRouteLoaderData(
    loaderRouteId,
  ) as KlientkontoerklaeringByIdLoaderData;
  if (!error && kke?.status === "Kladde" && metadata) {
    const formData =
      kke.jsonData && kke.formularType === "Formular1"
        ? JSON.parse(kke.jsonData, reviver)["form"]
        : KKE_FORM_INITIAL_VALUES;

    return (
      <KlientkontoerklaeringForm
        id={kke.id}
        kke={kke}
        initialValues={formData ?? KKE_FORM_INITIAL_VALUES}
        metadata={metadata}
        formularType={formularType}
      />
    );
  } else {
    if (error) {
      if (error === 404) {
        return <PageError msgText={"Erklæringen kunne ikke findes"} />;
      }
      return <PageError msg={`Erklæringen fejlede med en status ${error}`} />;
    } else if (kke?.status && kke.status !== "Kladde") {
      return <PageError msg={`Erklæringen er ${kke.status.toLowerCase()}`} />;
    } else {
      return null;
    }
  }
}
